import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// One-time cleanup of legacy theme preference (site is dark-mode only).
try { localStorage.removeItem("stratiq.theme"); } catch { /* ignore */ }

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
